import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={26}
    height={27}
    viewBox="0 0 26 27"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#fff'}
      d="M24.43 11.602H1.65a1.57 1.57 0 0 0-1.57 1.57v.9c0 .866.703 1.57 1.57 1.57h22.78a1.57 1.57 0 0 0 1.57-1.57v-.9a1.57 1.57 0 0 0-1.57-1.57Z"
    />
    <Path
      fill={props.fill || '#fff'}
      d="M11.03 2.244v22.78c0 .867.703 1.57 1.57 1.57h.9a1.57 1.57 0 0 0 1.57-1.57V2.244A1.57 1.57 0 0 0 13.5.674h-.9a1.57 1.57 0 0 0-1.57 1.57Z"
    />
  </Svg>
);
export default SvgComponent;
